import axiosInstance from "@/axios";

const getPreview = (lotIds, email) => {
  return axiosInstance.post(`/api/integration/bitrix/send/preview?profileEmail=${email}`, lotIds);
};

const send = (payload, email) => {
  return axiosInstance.post(
    `/api/integration/bitrix/send?profileEmail=${email}`,
    payload,
  );
};

const link = (payload) => {
  return axiosInstance.post("/api/integration/bitrix/oauth/link", payload);
};

const getMapping = (memberId) => {
  return axiosInstance.get(
    `/api/integration/bitrix/field-mappings?memberId=${memberId}`,
  );
};

const updateMapping = (memberId, payload) => {
  return axiosInstance.put(
    `/api/integration/bitrix/field-mappings?memberId=${memberId}`,
    payload,
  );
};

const checkConnection = (memberId) => {
  return axiosInstance.get(
    `/api/integration/bitrix/oauth/connection/status?member_id=${memberId}`,
  );
};

export { getPreview, send, link, getMapping, updateMapping, checkConnection };
